import axios from "axios";
import store from '../../redux/store';
import * as actions from "./LoginTypes";
import AppConsts from "../../appconst";

export const UserLogin = async (data) => {
    try {
        var result = await axios.post(AppConsts.apiBaseUrl + "/Login/Login", JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
                withCredentials: true,
            },
        })
            .then(response => {
                if (response.data.msg == "success") {
                    //GetAntiForgeryToken();
                    localStorage.setItem("token", response.data.token);
                    localStorage.setItem("authenticated", true);
                    localStorage.setItem("user", response.data.userCode);
                    localStorage.setItem("userId", response.data.userId);
                    localStorage.setItem("vendorCode", response.data.vendorCode);
                    store.dispatch({ type: actions.AUTHENTICATED, payload: { isAuthenticated: true } });
                    return response.data;
                }
                else {
                    return response.data;
                }
            })
            .catch(error => {
                return { msg: error.message };
            });
        return result;
    }
    catch (err) {
        return { msg: err.message };
    }
};

export const UserLogout = async () => {
    if (!localStorage.getItem("rememberme") == "true") {
        localStorage.removeItem("user");
    }

    localStorage.removeItem("authenticated");
    localStorage.removeItem("vendorCode");
    localStorage.removeItem("userId");
    localStorage.removeItem("token");
}

export const GetAntiForgeryToken = async () => {
    try {
        var result = await axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Login/GetToken",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                localStorage.setItem("X-Xsrf-Token", response.data);
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                result = "";
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return "";
    }
};

export const GetLoginCredentialsForRememberMe = async (data) => {
    try {
        var result = await axios({
            method: 'get',
            params: data,
            url: AppConsts.apiBaseUrl + "/Login/GetLoginCredentialsForRememberMe",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => {
                                UserLogout();
                                window.location.reload();
                            }
                        });
                    }
                }
                console.log({ content: err.message });
                result = "";
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return "";
    }
};